import { Modal } from "components/modal";
import React from "react";

import { UserSettingsForm } from "./userSettingsForm";

export const UserSettingsModal = ({ isOpen, close }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={close} title="User Settings">
      <UserSettingsForm onSuccess={close} onCancel={close} />
    </Modal>
  );
};

interface ModalProps {
  readonly isOpen: boolean;
  readonly close: () => void;
}
